import React from 'react';
import { formatNumber, formatPercent } from '../../service/workbench';

interface MetricCardProps {
  title: string;
  value?: number | null;
  unit?: string;
  hint?: React.ReactNode;
  percent?: boolean;
  emphasis?: boolean;
  change?: number | null;
  changeLabel?: string;
}

export default function MetricCard({
  title,
  value,
  unit,
  hint,
  percent,
  emphasis,
  change,
  changeLabel = '较上一周期'
}: MetricCardProps) {
  return (
    <section className="metric-card">
      <div className="metric-card__title">{title}</div>
      <div className={`metric-card__value ${emphasis ? 'is-emphasis' : ''}`}>
        {percent ? formatPercent(value) : formatNumber(value)}
        {unit && <span>{unit}</span>}
      </div>
      <div className="metric-card__hint">
        {change !== undefined && change !== null && (
          <span className={change >= 0 ? 'trend-up' : 'trend-down'}>
            {change >= 0 ? '↑' : '↓'} {Math.abs(change).toFixed(1)}% {changeLabel}
          </span>
        )}
        {hint}
      </div>
    </section>
  );
}
